<div class="text-input">
  <label  class="form-label">{{label}}</label>
  <input type="text" class="form-control" placeholder="{{placeholder}}" [(ngModel)]="value">
</div>
